import React from "react";
import { HiOutlineSparkles } from "react-icons/hi";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import { useModal } from "../../../../contexts/ui";
import { GenerateQuestionsModal } from "./Modal";

const ButtonLabel = styled.div`
  margin-left: 6px;
  user-select: none;
  margin-top: 2px;
`;

const Button = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #2cabe0;
`;

export function GenerateQuestions() {
  const { openModal, closeModal } = useModal();
  const { id } = useParams();

  return (
    <Button
      onClick={() => {
        openModal({
          title: "Generate questions with AI",
          content: (
            <GenerateQuestionsModal
              questionGroupId={id}
              onCancel={closeModal}
            />
          ),
          cancelAction: false,
        });
      }}
    >
      <HiOutlineSparkles />
      <ButtonLabel>Generate Questions</ButtonLabel>
    </Button>
  );
}
